import React from 'react'
import styled from 'styled-components'
import { Link, textContainer } from './shared'
import { contact } from '../data'

const Container = styled.footer`
  border-top: 4px solid var(--accent-alt);
  background-color: var(--bg-accent);
  color: var(--fg-accent);
  padding-top: 40px;
  padding-bottom: 40px;
  text-align: center;

  @media (min-width: 700px) {
    text-align: left;
  }
`

const TextBox = styled.div`
  ${textContainer}
  
  @media (min-width: 700px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  p {
    margin: 0;
    padding: 0;
    line-height: 1.5;
  }
`

const Info = styled.div`
  margin-bottom: 20px;
  @media (min-width: 700px) {
    margin-bottom: 0;
  }
`

const Footer = () => {
  const currentYear = new Date().getFullYear()
  return (
    <Container>
      <TextBox>
        <Info>
          <p>{contact.fullName}</p>
          <p>{contact.location}</p>
          <p><Link href={`mailto:${contact.email}`}>{contact.email}</Link></p>
          <p><Link href={`tel:${contact.phone}`}>{contact.displayPhone}</Link></p>
        </Info>
        <p>&copy; 2022{currentYear === 2022 ? '' : ` - ${currentYear}`}. Website by <Link href="https://www.arielkaplan.com" rel="noreferrer noopener" target="_blank">Ariel Kaplan</Link></p>
      </TextBox>
    </Container>
  )
}

export default Footer
